import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
interface SuccessMessageProps {
  referenceNumber: number;
  onClose: () => void;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({ referenceNumber, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <Box
      onClick={onClose}
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(16, 47, 77, 0.5)',
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          backgroundColor: 'white',
          padding: { xs: 3, sm: 4 }, margin: 3, maxWidth: 480,
          borderRadius: 2,
          textAlign: 'center',
        }}
      >
        <CheckCircleIcon sx={{ fontSize: '4rem', color: 'success.main' }} />
        <Typography variant="h5" sx={{ mt: 2 }}>
          Millifærslan tókst!
        </Typography>
        <Typography variant="body1" sx={{ marginTop: '0.5rem' }}>
          Tilvísunarnúmer: {referenceNumber}
        </Typography>
      </Box>
    </Box>
  );
};

export default SuccessMessage;
